import { Typography } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import type { IHistoryActivityItem } from './types';

const { Text } = Typography;

interface IHistoryEntryProps {
  entry: IHistoryActivityItem;
  onEntryNavigate?: (patientGuid: string) => void;
}

const HistoryEntry = ({ entry, onEntryNavigate }: IHistoryEntryProps) => {
  const { t } = useTranslation();
  const {
    description,
    program,
    actorName,
    patientName,
    timestampLabel,
    patientGuid,
    actionKey,
    actionLabel,
  } = entry;

  const isNavigable = Boolean(patientGuid);

  const handleClick = () => {
    if (patientGuid) {
      onEntryNavigate?.(patientGuid);
    }
  };

  const actionText = actionKey
    ? t(`homeDashboard.history.actions.${actionKey}`, {
        defaultValue: actionLabel || description,
      })
    : actionLabel || description;

  return (
    <button
      type="button"
      className={classNames(styles.entry, {
        [styles['entry-clickable']]: isNavigable,
      })}
      onClick={handleClick}
      disabled={!isNavigable}
    >
      <div className={styles['entry-header']}>
        <Text className={styles.description}>
          {actorName ? (
            <>
              <span className={styles['actor-name']}>{actorName}</span>{' '}
            </>
          ) : null}
          {actionText}
          {patientName ? (
            <>
              {' '}
              <span className={styles['patient-name']}>{patientName}</span>
            </>
          ) : null}
        </Text>
        {program?.label ? (
          <span
            className={classNames(styles['program-tag'], {
              [styles['program-tag-rpm']]: program.variant === 'rpm',
              [styles['program-tag-ccm']]: program.variant === 'ccm',
            })}
          >
            {program.label}
          </span>
        ) : null}
      </div>

      <div className={styles['entry-meta']}>
        <Text className={styles['timestamp-label']}>{timestampLabel}</Text>
      </div>
    </button>
  );
};

export default HistoryEntry;
